export default __webpack_public_path__ + "static/media/ysl.481f7015.png";